import React from "react";
import {UnitStatusSelector} from "./UnitStatusSelector";

export const UnitStatus = ({currentStatus, unitStatus, onChange, errors}) => {

  return (
      <div className="flex items-center space-x-3">
        <label className="text-xs font-medium text-gray-600">Status:</label>
        <UnitStatusSelector
            currentStatus={currentStatus}
            unitStatus={unitStatus}
            onChange={onChange}
            errors={errors}
        />
        <div className="text-xs text-gray-500">
          Letzter Status: {new Date().toLocaleDateString('de-DE')}
        </div>
      </div>);
}